import type { ListShipment } from '@fv/client-types'

import { getCarrierDetails } from '@/utils/shipmentFuncs'

import ActiveShipmentCardHeader from './ActiveShipmentCardHeader'
import PendingShipmentCardHeader from './PendingShipmentCardHeader'
import type { SelectableShipmentProps } from './types'

type ShipmentCardHeaderProps = Partial<SelectableShipmentProps> & {
  shipment: ListShipment
}

const ShipmentCardHeader = ({
  shipment,
  selected,
  setSelected,
}: ShipmentCardHeaderProps) => {
  const { status } = shipment
  const carrierDetails = getCarrierDetails(shipment)
  const isPending = status === 'awarded' || status === 'pending'

  return (
    <div className="flex border-b border-fv-gray">
      {isPending ? (
        <PendingShipmentCardHeader shipment={shipment} />
      ) : (
        <ActiveShipmentCardHeader
          carrierName={carrierDetails}
          shipment={shipment}
          selected={selected}
          setSelected={setSelected}
        />
      )}
    </div>
  )
}

export default ShipmentCardHeader
